import { NextResponse } from 'next/server';
import type { NextRequest } from 'next/server';

// URL pública del dominio — usada para redirects correctos detrás del proxy Apache
const PUBLIC_URL = process.env.NEXT_PUBLIC_APP_URL ?? 'https://opsustuidio.alexanderpaez.com.ve';

export function middleware(request: NextRequest) {
  const token      = request.cookies.get('accessToken')?.value;
  const pathname   = request.nextUrl.pathname;
  const isAuthPage = pathname.startsWith('/auth');

  if (!token && !isAuthPage) {
    return NextResponse.redirect(`${PUBLIC_URL}/auth`);
  }
  if (token && isAuthPage) {
    return NextResponse.redirect(`${PUBLIC_URL}/dashboard`);
  }
  return NextResponse.next();
}

export const config = {
  matcher: ['/((?!_next/static|_next/image|favicon.ico).*)'],
};
